<template>
  <div>
    <div>
      <van-nav-bar title="全部客户" left-arrow @click-left="onClickLeft" />
    </div>
  </div>
</template>
<script>
import API from '@/services/h5/my'
export default {
  data() {
    return {
      id: ''
    }
  },
  methods: {
    onClickLeft() {
      window.history.go(-1)
    },
    getCustomerIndetail() {
      let params = {
        id: this.$route.params.id
      }
      API.customerIndetail(params).then(res => {
        console.log(res)
      })
    }
  },
  mounted() {
    this.getCustomerIndetail()
  }
}
</script>